module.exports = __webpack_public_path__ + "img/la_lo.b27c70ed.jpg";